module.exports = __webpack_public_path__ + "static/media/create-event-sidebar.aa888383.svg";